import noUiSlider from "nouislider";

const Filter = {
  timeout: null,

  init: function () {
    Filter.events();
    Filter.price();
    Filter.checkFilters();
  },

  events: function () {
    // On order by change
    $("body").on("change", "select[name=orderby]", function () {
      Filter.filter();
    });

    // Mobile.
    $(".toggle-filters").on("click", function () {
      $(".product-filters").addClass("product-filters--open");
      $("html").addClass("no-scroll");
    });

    // Close filters
    $(".close-filters").on("click", function () {
      $(".product-filters").removeClass("product-filters--open");
      $(".filter-multiselect").removeClass("filter-multiselect--open");
      $("html").removeClass("no-scroll");
    });

    // Submit filters
    $(".submit-filters").on("click", function (e) {
      e.preventDefault();
      $(".filter-multiselect").removeClass("filter-multiselect--open");
      $(".product-filters__top").removeClass("visible");
      $(".product-filters").removeClass("product-filters--open");
      $("html").removeClass("no-scroll");
    });

    // Open filter.
    $(".toggle-filter").on("click", function () {
      $("#filter .filter").toggleClass("filter--open");
    });

    // Go back
    $(".product-filters__back").on("click", function () {
      $(".product-filter__wrap").removeClass("open");
      $(".filter-multiselect").removeClass("filter-multiselect--open");
      $(".product-filters__top").removeClass("visible");
    });

    // Clear filters
    $(".clear-filters").on("click", function () {
      console.log($("#filter"));
      $("#filter")[0].reset();
      Filter.setSelectedCount();
      $("#filter").find('[type="checkbox"]').prop("checked", false);

      $(".filter-multiselect").removeClass("filter-multiselect--open");
      $(".product-filters__top").removeClass("visible");
      Filter.filter();
    });

    // Multiselect.
    $(".filter-multiselect__main").on("click", function () {
      const btn = $(this);
      const wrap = btn.parent();
      const condition = wrap.hasClass("filter-multiselect--open");

      $(".filter-multiselect").removeClass("filter-multiselect--open");

      if (condition) {
        wrap.removeClass("filter-multiselect--open");
      } else {
        wrap.addClass("filter-multiselect--open");
      }

      $(".product-filters__name").text(btn.children("span").text());
      $(".product-filters__top").addClass("visible");
    });

    $(document).mouseup(function (e) {
      if ($(window).outerWidth() < 900) {
        return;
      }
      let container = $(".filter-multiselect");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("filter-multiselect--open");
      }
    });

    // On attribute change
    $("#filter input").on("change", function () {
      Filter.setSelectedCount();
      Filter.filter();
    });

    $("body").on("click", ".page-numbers", (e) => {
      e.preventDefault();

      const activePage = parseInt($(".page-numbers.current").text());
      const btnEl = $(e.currentTarget);

      const urlParams = new URLSearchParams(window.location.search);
      let pageParamValue = parseInt(urlParams.get("page"), 10);
      let page = isNaN(pageParamValue) ? 1 : pageParamValue;

      if (btnEl.hasClass("disabled")) {
        return;
      } else if (btnEl.hasClass("prev")) {
        page -= 1;
      } else if (btnEl.hasClass("next")) {
        page += 1;
      } else {
        page = parseInt(btnEl.text());
      }

      $("html,body").animate({
        scrollTop: $("#product-wrap").offset().top - 125,
      });

      Filter.filter(page);
    });
  },

  setSelectedCount: function () {
    // Selected options count.
    $(".filter-multiselect").each(function () {
      const wrap = $(this);
      const countEl = wrap.find(".filter-multiselect__count");
      const count = wrap.find("input:checked").length;

      if (count > 0) {
        countEl.text(`(${count})`);
      } else {
        countEl.text("");
      }
    });
  },

  price: function () {
    const priceWrapEl = $(".product-filter--price");
    if (priceWrapEl.length) {
      // construct slider
      let slider = priceWrapEl.find(".product-filter__slider");

      let step = slider.data("step");
      let min = slider.data("min");
      let max = slider.data("max");

      if (min == max) {
        return;
      }

      let selected_min = priceWrapEl.find('input[name="price_from"]').val();
      let selected_max = priceWrapEl.find('input[name="price_to"]').val();

      noUiSlider.create(slider[0], {
        start: [selected_min, selected_max],
        connect: true,
        step: step,
        range: {
          min: min,
          max: max,
        },
      });

      // Inputs
      slider[0].noUiSlider.on("update", function (values) {
        // Header
        priceWrapEl.find(".product-filter__price-min span").text(values[0]);
        priceWrapEl.find(".product-filter__price-max span").text(values[1]);

        // Inputs
        priceWrapEl.find('input[name="price_from"]').val(values[0]);
        priceWrapEl.find('input[name="price_to"]').val(values[1]);
      });

      priceWrapEl.find('input[name="price_from"]').on("change", function () {
        slider[0].noUiSlider.set([$(this).val(), null]);
      });

      priceWrapEl.find('input[name="price_to"]').on("change", function () {
        slider[0].noUiSlider.set([null, $(this).val()]);
      });

      // Inputs
      slider[0].noUiSlider.on("set", function () {
        Filter.filter();
      });
    }
  },

  filter: function (page = 1) {
    clearTimeout(Filter.timeout);
    $("#product-wrap").addClass("loading");

    const filterFormEl = $("form#filter");

    // Construct arguments for each Attribute
    let attributes = [];
    filterFormEl.find(".filter-multiselect").each(function () {
      let group = $(this);
      let attr = group.data("name");

      if (attr) {
        let items = group.find("input:checked");
        if (items.length) {
          attributes.push({
            taxonomy: attr,
            terms: [],
          });
          let index = attributes.length - 1;
          items.each(function () {
            attributes[index].terms.push($(this).val());
          });
        }
      }
    });

    // Pricing
    const priceEl = filterFormEl.find(".product-filter--price");
    let min = priceEl.find('input[name="price_from"]').val();
    let max = priceEl.find('input[name="price_to"]').val();

    let price_range = {
      min: min,
      max: max,
    };

    // Construct URL
    const params = new URLSearchParams();

    // Page
    params.append("page", page);

    // Order
    let order_by = $('select[name="orderby"]').val();
    if (order_by) {
      params.append("order_by", order_by);
    }

    // Filter attributes
    let query_attr = [];
    if (attributes.length) {
      $.each(attributes, function (index, attribute) {
        query_attr.push({
          taxonomy: attribute.taxonomy,
          terms: attribute.terms,
        });
      });
      params.append("attributes", JSON.stringify(query_attr));
    }

    // Price
    let send_price_range = false;
    const priceSlider = $(".product-filter--price .product-filter__slider");
    let price_this = price_range.min > priceSlider.data("min");
    let price_that = price_range.max < priceSlider.data("max");
    if (price_this || price_that) {
      send_price_range = true;
      params.append("price_range", JSON.stringify(price_range));
    }

    // Tags
    const tags = $("#filter input[name=tags]");
    if (tags.val()) {
      params.append("tags", tags.val());
    }

    // Check filter
    Filter.checkFilters();

    // Set URL
    const base_url = window.location.origin + window.location.pathname;
    const url = base_url + "?" + params.toString();
    history.pushState(null, null, url);

    let data = {
      action: "filter_products",
      order_by: order_by,
      page: page,
      tags: tags.val(),
      attributes: JSON.stringify(query_attr),
      per_page: $('#filter-extra input[name="per_page"]').val(),
      term_id: $('#filter-extra input[name="term_id"]').val(),
      nonce: $("#prod-nonce").val(),
    };
    if (send_price_range) {
      data.price_range = price_range;
    }

    // Throttle ajax.
    Filter.timeout = setTimeout(() => {
      $.ajax({
        url: ajaxurl,
        type: "POST",
        data: data,
      })
        .done(function (response) {
          if (response.success) {
            $("#product-header").html(response.data.header);

            $("#products").html(response.data.products);

            $("#pager").html(response.data.pager);
          } else {
            $("#products").html(response.data.message);
          }
        })
        .always(function () {
          $("#product-wrap").removeClass("loading");
        });
    }, 1000);
  },

  checkFilters: function () {
    const filterFormEl = $("#filter");

    let filters = {};

    // Attributes
    let attributes = [];
    $(".filter-multiselect").each(function () {
      let group = $(this);
      let attr = group.data("name");

      if (attr) {
        let items = group.find("input:checked");
        if (items.length) {
          attributes.push({
            taxonomy: attr,
            terms: [],
          });
          let index = attributes.length - 1;
          items.each(function () {
            attributes[index].terms.push($(this).val());
          });
        }
      }
    });

    if (attributes.length > 0) {
      filters.attributes = true;
    }

    // Price
    const priceEl = $(".product-filter--price");
    let min = priceEl.find('input[name="price_from"]').val();
    let max = priceEl.find('input[name="price_to"]').val();

    let price_range = {
      min: min,
      max: max,
    };
    const priceSlider = $(".product-filter--price .product-filter__slider");
    let price_this = price_range.min > priceSlider.data("min");
    let price_that = price_range.max < priceSlider.data("max");
    if (price_this || price_that) {
      filters.price_range = true;
    }

    if (Object.keys(filters).length > 0) {
      $(".clear-filters").show();
    } else {
      $(".clear-filters").hide();
    }
  },
};

export default Filter;
